const ABSOLUTE_URL = /^https?:\/\//;
const EXTERNAL_HREF = /^(https?:|mailto:|tel:)/;

export function isExternalHref(href: string): boolean {
  return EXTERNAL_HREF.test(href);
}

export function externalLinkProps(href: string): {target: '_blank'; rel: 'noopener noreferrer'} | Record<string, never> {
  return ABSOLUTE_URL.test(href) ? {target: '_blank', rel: 'noopener noreferrer'} : {};
}
